import anime from 'animejs'

/**
 * morphingBG.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2017, Codrops
 * http://www.codrops.com
 */
export default class MorphingBG {

  constructor (el) {
    var t = this;
    this.DOM    = {}
    this.DOM.el = el;
    this.DOM.parent = el.parentNode;
    // this.DOM.el.style.opacity    = 0;
    this.DOM.el.style.transition = 'transform 2s ease-out';
    this.DOM.pathEl = this.DOM.el.querySelector('path');
    this.paths      = this.DOM.pathEl.getAttribute('pathdata:id').split(';');
    this.paths.splice(this.paths.length, 0, this.DOM.pathEl.getAttribute('d'));
    // this.win        = { width: window.innerWidth, height: window.innerHeight }
    this.rect = this.DOM.parent.getBoundingClientRect();
    this.win        = { width: this.rect.width, height: this.rect.height }

    this.points = [];
    this.paths.forEach( function(element, index) {
      t.points.push({
        value: element
      })
    });

    // console.log(this.DOM.el, this.paths, this.points);
    // console.log(this.DOM.parent, this.win);

    this.animate();
    this.initEvents();
  }

  animate () {
    anime.remove(this.DOM.pathEl);
    this.animation = anime({
      targets: this.DOM.pathEl,
      duration: 4000,
      easing: 'cubicBezier(0.5,0,0.5,1)',
      // easing: 'easeOutQuad',
      d: this.points,
      loop: true,
      autoplay: false,
    });
  }

  initEvents () {
    const t = this;

    // Mousemove event / Tilt functionality.
    const tilt = {
      tx: this.win.width / 8,
      ty: this.win.height / 8,
      rz: 45,
      sx: [0.8,1.2],
      // sy: [0.8,2]
      sy: [0.8,1.2]
    };

    const onMouseMoveFn = (ev) => {
      requestAnimationFrame(() => {
        // if ( !this.started ) {
        //   this.started = true;
        //   anime({
        //     targets: this.DOM.el,
        //     duration: App.variables.transition_fast,
        //     easing: 'linear',
        //     // opacity: [0,1]
        //     opacity: [0,.6]
        //   });
        // }
        // else {
          const mousepos = t.getMousePos(ev);
          // console.log('mousepos', mousepos);
          const rotZ = 2*tilt.rz/this.win.height*mousepos.y - tilt.rz;
          var scaleX = mousepos.x < this.win.width/2 ? t.lineEq(tilt.sx[0],tilt.sx[1],this.win.width/2,0,mousepos.x) : t.lineEq(tilt.sx[1],tilt.sx[0],this.win.width,this.win.width/2,mousepos.x);
          var scaleY = mousepos.y < this.win.height/2 ? t.lineEq(tilt.sy[0],tilt.sy[1],this.win.height/2,0,mousepos.y) : t.lineEq(tilt.sy[1],tilt.sy[0],this.win.height,this.win.height/2,mousepos.y);
          const transX = 2*tilt.tx/this.win.width*mousepos.x - tilt.tx;
          const transY = 2*tilt.ty/this.win.height*mousepos.y - tilt.ty;

          // console.log('scale', scaleX, scaleY );
          // console.log('translate', transX, transY );

          // this.DOM.el.style.transform = `translate3d(${transX}px, ${transY}px,0) rotate3d(0,0,1,${rotZ}deg) scale3d(${scaleX},${scaleY},1)`;
          this.DOM.el.style.transform = `translate3d(${transX}px,${transY}px,0) rotate3d(0,0,1,${rotZ}deg) scale3d(${scaleX},${scaleY},1)`;
        // }
      });
    };

    this.DOM.parent.addEventListener('mouseenter', (e) => {
      this.rect = this.DOM.parent.getBoundingClientRect();
      this.animation.play();
    });
    this.DOM.parent.addEventListener('mouseleave', (e) => {
      this.animation.pause();
    });

    // Window resize
    // const onResizeFn = debounce(() => this.win = { width: window.innerWidth, height: window.innerHeight }, 200);
    const onResizeFn = debounce(() => {
      this.rect = this.DOM.parent.getBoundingClientRect();
      this.win  = { width: this.rect.width, height: this.rect.height }
    }, 200);

    // document.addEventListener('mousemove', onMouseMoveFn)
    // document.addEventListener('mousemove', throttle( e => {
    this.DOM.parent.addEventListener('mousemove', throttle( e => {
      onMouseMoveFn(e);
    }, 30 ));

    // // document.addEventListener('touchstart', onMouseMoveFn)
    // document.addEventListener('touchstart', throttle( e => {
    //   onMouseMoveFn(e);
    // }, 30 ));

    window.addEventListener('resize', ev => onResizeFn());
  }

  // Equation of a line
  lineEq (y2, y1, x2, x1, currentVal) {
    // y = mx + b;
    const m = (y2 - y1) / (x2 - x1);
    const b = y1 - m * x1;
    return m * currentVal + b;
  }

  // From http://www.quirksmode.org/js/events_properties.html#position
  getMousePos (e) {
    let posx = 0;
    let posy = 0;
    if (!e) { let e = window.event; }

    // if (e.pageX || e.pageY)     {
    //   posx = e.pageX;
    //   posy = e.pageY;
    // }
    // else if (e.clientX || e.clientY)    {
    //   posx = e.clientX + document.body.scrollLeft
    //       + document.documentElement.scrollLeft;
    //   posy = e.clientY + document.body.scrollTop
    //       + document.documentElement.scrollTop;
    // }

    posx = e.clientX - this.rect.left;
    posy = e.clientY - this.rect.top;
    // posx = e.clientX;
    // posy = e.clientY;

    return {
      x : posx,
      y : posy
    };
  }

}
